var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDefensive3 = function SvgDefensive3(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 84 84"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 84,
    height: 84,
    fill: "#8D48FF",
    rx: 12
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M64.99 42.501c0 .786-.644 1.425-1.436 1.425H52.752l-9.744 9.658a1.44 1.44 0 0 1-1.017.416 1.43 1.43 0 0 1-1.017-.416l-9.744-9.658H20.437A1.43 1.43 0 0 1 19 42.5c0-.785.645-1.424 1.437-1.424H31.24l9.744-9.658a1.444 1.444 0 0 1 2.034 0l9.744 9.658h10.802c.793 0 1.437.639 1.437 1.424z"
  })));
};
export default SvgDefensive3;